// extracted by mini-css-extract-plugin
module.exports = {"container":"WindowContainer_container__J-d_S","inner-container":"WindowContainer_inner-container__2wXdo","close":"WindowContainer_close__1Ai8Q","bar":"WindowContainer_bar__1PG88"};